<template>
  <div>
    <el-dialog
      v-el-drag-dialog
      custom-class
      :close-on-click-modal="false"
      :visible.sync="innerVisible"
      :title="$t('CargoMsg.Cargo_PushResultLog')"
      @close="innerVisible=false"
    >
      <div class="app-main-inner-row row-grid" style="padding: 0;">
        <cargo-ag-grid
          :show-side-bar="false"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
          :style="{width:'100%',height:'315px'}"
        />
      </div>
      <div slot="footer">
        <el-button v-if="logSource==='job'" no="1" type="primary" plain @click="sendOrder">{{ $t('CargoMsg.Cargo_sendOcOrder') }}</el-button>
        <el-button v-if="logSource==='job'" no="2" type="primary" plain @click="sendTracking">{{ $t('CargoMsg.Cargo_sendOcTracking') }}</el-button>
        <el-button v-if="logSource==='file'" no="3" type="primary" plain @click="sendFile">{{ $t('CargoMsg.Cargo_sendOcFile') }}</el-button>
        <el-button v-if="logSource==='billing'" no="4" type="primary" plain @click="sendBilling">{{ $t('CargoMsg.Cargo_sendOcBilling') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ColumnUtils from '@/utils/ColumnUtils'
import { getLoading } from '@/utils/utilBaseElement'
import { getPushResultLogByJobKeys, sendOrderByJobKeys, sendTrackingByJobKeys, sendFileByJobKeys, getPushResultByReqLogByJobKeys } from '@/api/seaExport/seaExportJob'
import { sendBillingByJobKeys } from '@/api/clearing/billingNative'

export default {
  name: 'PushResultLogDialog',
  props: {
    visible: { type: Boolean, required: true },
    jobUuid: { type: String, required: true },
    jobKeys: { type: Array, default: null },
    logSource: { type: String, default: 'job' } // 1、job:订单信息、轨迹信息 2、file:文件信息 3、billing:账单信息
  },
  data() {
    return {
      loading: false,
      innerVisible: false,
      gridOptions: {},
      gridParams: {},
      gridApi: {},
      columnDefs: [
        { headerName: this.$t('CargoMsg.Cargo_Sender'), field: 'sendName', width: 120, sortable: false },
        { headerName: this.$t('CargoMsg.Cargo_SendContent'), field: 'sendContent', width: 120, sortable: false,
          cellRenderer: (params) => {
            return this.sendContentLabelFunc(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_SendDate'), field: 'pushTime', width: 140, sortable: false,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_ResultSuccess'), field: 'resultSuccess', width: 110, sortable: false,
          cellRenderer: (params) => {
            return params.value ? this.$t('Message.Success') : this.$t('Message.Failure')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_ResultMessage'), field: 'resultMessage', width: 236, sortable: false }
      ],
      sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
      rowData: []
    }
  },
  computed: {
    finalJobKeys() {
      return this.jobKeys ? this.jobKeys : [this.jobUuid]
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.toQuery()
      }
    },
    innerVisible(newVal) {
      if (!newVal) {
        this.rowData = []
      }
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.innerVisible = true
      this.toQuery()
    }
  },
  methods: {
    toQuery() {
      if (['file', 'billing'].includes(this.logSource)) {
        this.toQueryReqLog()
        return
      }
      if (!this.jobUuid) {
        this.$message.warning(this.$t('queryJob.BusinessUUIDCannotBeEmpty'))
        return
      }
      this.loading = getLoading()
      getPushResultLogByJobKeys(this.finalJobKeys).then(res => {
        this.rowData = res.data
      }).finally(() => {
        this.loading.close()
      })
    },
    toQueryReqLog() {
      if (!this.jobUuid) return
      this.loading = getLoading()
      getPushResultByReqLogByJobKeys({ 'keys': this.finalJobKeys, 'anyStr1': this.logSource }).then(res => {
        this.rowData = res.data
      }).finally(() => {
        this.loading.close()
      })
    },
    sendOrder() {
      if (!this.jobUuid) {
        this.$message.warning(this.$t('queryJob.BusinessUUIDCannotBeEmpty'))
        return
      }
      this.loading = getLoading()
      sendOrderByJobKeys(this.finalJobKeys).then(res => {
        this.toQuery()
      }).finally(() => {
        this.loading.close()
      })
    },
    sendTracking() {
      if (!this.jobUuid) {
        this.$message.warning(this.$t('queryJob.BusinessUUIDCannotBeEmpty'))
        return
      }
      this.loading = getLoading()
      sendTrackingByJobKeys(this.finalJobKeys).then(res => {
        this.toQuery()
      }).finally(() => {
        this.loading.close()
      })
    },
    sendFile() {
      if (!this.jobUuid) {
        this.$message.warning(this.$t('queryJob.BusinessUUIDCannotBeEmpty'))
        return
      }
      this.loading = getLoading()
      sendFileByJobKeys(this.finalJobKeys).then(res => {
        this.toQuery()
      }).finally(() => {
        this.loading.close()
      })
    },
    sendBilling() {
      if (!this.jobUuid) {
        this.$message.warning(this.$t('queryJob.BillUUIDCannotBeEmpty'))
        return
      }
      this.loading = getLoading()
      sendBillingByJobKeys(this.finalJobKeys).then(res => {
        this.toQuery()
      }).finally(() => {
        this.loading.close()
      })
    },
    sendContentLabelFunc(value) {
      switch (value) {
        case 'file':
          return this.$t('queryJob.FileInformation')
          break
        case 'billing':
          return this.$t('queryJob.BillingInformation')
          break
      }
      return value
    }
  }
}
</script>

<style lang="scss">
.el-loading-mask.is-fullscreen {
  z-index: 999999 !important;
}
</style>

